// import { createRouter, createWebHistory } from 'vue-router'

import Vue from 'vue'
import VueRouter from 'vue-router'
import Root from './pages/Root'
import Article from './pages/Article'

const routes = [
  { path: '/', name: 'root', component: Root },
  { path: '/article/:id', name: 'article', component: Article },
];

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/news',
  routes
})

export default router
